import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useMembership } from "@/hooks/useMembership";
import { Loader2 } from "lucide-react";
import { FoundingMembershipCTA } from "@/components/FoundingMembershipCTA";
import { useEffect } from "react";
import { isMembershipPublic } from "@/lib/membership-launch";

export const Route = createFileRoute("/register-membership")({
  head: () => ({
    meta: [
      { title: "Complete your registration | Recovery Trauma™" },
      {
        name: "description",
        content:
          "Member registration for Recovery Trauma™ — complete your Membership and unlock full access.",
      },
      { name: "robots", content: "noindex,nofollow" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://recoverytrauma.com/register-membership",
      },
    ],
  }),
  component: RegisterMembershipPage,
});

function RegisterMembershipPage() {
  const { loading, isAdmin } = useMembership();
  const navigate = useNavigate();
  const publicLaunch = isMembershipPublic();

  useEffect(() => {
    if (loading) return;
    if (publicLaunch || isAdmin) navigate({ to: "/choose-membership", replace: true });
  }, [loading, isAdmin, publicLaunch, navigate]);

  if (loading) {
    return (
      <div className="mx-auto flex min-h-[60vh] max-w-2xl items-center justify-center px-4">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (isAdmin || publicLaunch) return null;

  return (
    <div className="min-h-[100svh] bg-gradient-to-b from-background via-background to-[var(--gold-soft)]/25 px-4 py-16 sm:py-24">
      <div className="mx-auto flex max-w-3xl items-center justify-center">
        <FoundingMembershipCTA ctaHref="/choose-membership" decideLaterHref="/" />
      </div>
    </div>
  );
}
